module.exports = __webpack_public_path__ + "static/trave1-32f49b3d293956a9da422bfd1b1c691a.jpg";